import type { TClientEnv } from "./client-env-schema"
import { clientEnvSchema } from "./client-env-schema"

function parseClientEnv(rawEnv: ImportMetaEnv): TClientEnv {
  const parsedEnv = clientEnvSchema.parse(rawEnv, {
    error: (issue) => `🚨 ENV VAR SETUP ERROR 🚨 ${issue.code}`,
  })
  return parsedEnv
}

let cachedClientEnv: TClientEnv | null = null

/**
 * Returns the parsed client environment.
 *
 * Use this whenever application code needs an environment variable; direct
 * `import.meta.env` access bypasses the runtime parsing and inferred types.
 *
 * One exception: a condition whose purpose is to make the bundler *remove* code.
 * Vite replaces the exact token `import.meta.env.DEV` (and `PROD`, `MODE`) with a
 * literal at build time, so `if (import.meta.env.DEV) { ... }` becomes `if (false)`
 * in a production build and the block is dropped, together with anything it
 * dynamically imports. `getClientEnv().DEV` yields the same value but through a
 * function call the bundler cannot see through, so the branch and its imports
 * survive into the bundle. Reading a value: use this function. Gating code out of
 * the bundle: use the literal, and say so in a comment. See entry.client.tsx.
 */
export function getClientEnv(): TClientEnv {
  if (cachedClientEnv !== null) {
    return cachedClientEnv
  }

  const parsedEnv = parseClientEnv(import.meta.env)
  cachedClientEnv = parsedEnv
  return parsedEnv
}
